import styled from 'styled-components';
import { PrimaryButton } from './PrimaryButton';

export const RedButton = styled(PrimaryButton)`
    border-color: ${({ theme }) => theme.red300};
    background: ${({ theme }) => theme.red300};
    box-shadow: 0px 20px 25px ${({ theme }) => theme.red100};
`;
